import * as Popover from "@radix-ui/react-popover";
import { ComponentProps, PropsWithChildren } from "react";
import { Icon } from "react-migration/components/Icon";

interface InfoPopoverProps extends PropsWithChildren {
  popoverSide?: "top" | "bottom" | "left" | "right";
  size?: ComponentProps<typeof Icon>["size"];
}

export function InfoPopover({ children, size = "sm", popoverSide = "top" }: InfoPopoverProps) {
  return (
    <Popover.Root>
      <Popover.Trigger className="text-neutral-400 hover:text-neutral-500">
        <Icon icon="icon-lt-information-line" size={size} cursor="pointer" />
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          side={popoverSide}
          sideOffset={4}
          className="max-w-xs px-5 py-3 text-xs text-left text-white rounded-sm shadow-md bg-neutral-700"
        >
          <Popover.Arrow className="fill-neutral-700" />
          {children}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
